import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AttendanceCustomTimeRangeDayEnum } from 'generated/resources/graphql'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import { useCustomTimeRange } from 'modules/attendance/hooks/useCustomTimeRange'
import { translateDayInSingular } from 'modules/attendance/lib/translateDays'

interface NewTimeBlockModalProps {
  onChange: (value: AttendanceCustomTimeRangeDayEnum[]) => void
  isEdit: boolean
  daysSelected: string[]
  error?: string
}

const NewTimeBlockModal: React.FC<NewTimeBlockModalProps> = ({
  onChange,
  isEdit,
  daysSelected,
  error,
}) => {
  const { dayEnums } = useCustomTimeRange()

  const options = dayEnums.map((day) => {
    const translatedDay = translateDayInSingular(day)

    return (
      <Selector.Option
        key={translatedDay}
        value={day}
        label={translatedDay}
        searchValue={translatedDay}
      >
        {translatedDay}
      </Selector.Option>
    )
  })

  return (
    <Box width="full">
      <Selector.Popover
        label={i18n.t('time_tracking.settings.time_blocks.categories.modals.days')}
        placeholder={i18n.t('common.select')}
        blankLabel={i18n.t('common.select')}
        value={daysSelected}
        // eslint-disable-next-line no-type-assertion/no-type-assertion
        onChange={(value) => onChange(value as AttendanceCustomTimeRangeDayEnum[])}
        isMultiSelect
        headerLabel={i18n.t('time_tracking.settings.time_blocks.categories.modals.days')}
        error={error}
        isDisabled={isEdit}
        hasSearch={false}
      >
        {options}
      </Selector.Popover>
    </Box>
  )
}

export default NewTimeBlockModal
